module.exports = __webpack_public_path__ + "3ec67ab307b3fe3f7357824ffb4934ab.MP3";